/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module tenant
 */

export const tenantApi = {
    index,
    create,
    retrieve,
    update,
    destroy,
};

const ROUTE = '/tenants';

function index() {
    const response = window.centralAxios.get(ROUTE);
    return response.data.data;
}

async function create(tenant) {
    const response = await window.centralAxios.post(ROUTE, tenant);
    return response.data.data;
}

async function retrieve(tenantId) {
    const response = await window.centralAxios.get(`${ROUTE}/${tenantId}`);
    return response.data.data;
}

async function update(tenantId, tenant) {
    const response = await window.centralAxios.patch(`${ROUTE}/${tenantId}`, tenant);
    return response.data.data;
}

async function destroy(tenantId) {
    const response = await window.centralAxios.delete(`${ROUTE}/${tenantId}`);
    return response.data.data;
}
